<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <span>日期：</span>
      <el-date-picker
        v-model="rDate"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-input
        :value="`${MaterialName || ''}${
          MaterialCode ? '(' + MaterialCode + ')' : ''
        }`"
        clearable
        placeholder=" 请点击右侧按钮选择备件信息"
        disabled
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button
        type="primary"
        @click="addList"
        style="width: 100px; margin-left: 10px"
        >选择备件</el-button
      >
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
      >
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column
          label="日期"
          width="200"
          align="center"
          prop="StorTime"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.StorTime
                ? moment(scope.row.StorTime).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="单据类型"
          width="160"
          align="center"
          prop="Type"
          sortable
        >
        </el-table-column>
        <el-table-column label="入库数量" align="center" prop="iQty" sortable>
        </el-table-column>
        <el-table-column label="出库数量" align="center" prop="oQty" sortable>
        </el-table-column>
        <el-table-column label="结存数量" align="center" prop="tQty" sortable>
        </el-table-column>
      </el-table>
      <!-- <div
        style="height: 40px; display: flex; align-items: center; justify-content: right"
      >
        <el-pagination
          style="margin-top: 10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div> -->
    </div>
    <Fittings
      ref="Fittings"
      @select="FittingsChange"
      type="radio"
      :MaterialType="FittingsTreeSearch"
    ></Fittings>
  </div>
</template>
<script>
import moment from 'moment'
import Fittings from '@/components/Fittings/Fittings'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      moment,
      searchData: {
        MaterialId: '',
        sStorTime: '',
        eStorTime: '',
      },
      MaterialName: '',
      MaterialCode: '',
      rDate: [],
      tableData: [],
      totalData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: {
    Fittings,
  },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.rDate = [firstDay, lastDay]
      }
    },
    handleExport() {
      this.searchData.sStorTime = this.rDate ? this.rDate[0] : ''
      this.searchData.eStorTime = this.rDate ? this.rDate[1] : ''
      if (
        this.searchData.sStorTime &&
        this.searchData.sStorTime &&
        this.searchData.MaterialId
      ) {
        tools.download(
          this.$rootUrl +
            `/PB/PB_Material/ExportFlowsToExcel?MaterialId=${this.searchData.MaterialId}&sStorTime=${this.searchData.sStorTime}&eStorTime=${this.searchData.eStorTime}`,
          '出入库流水',
          '.xlsx',
          'get'
        )
      } else {
        this.$notify.warning('请选择日期与备件后查询')
      }
    },
    FittingsChange(arr) {
      console.log(arr)
      this.searchData.MaterialId = arr[0].Id
      this.MaterialName = arr[0].Name
      this.MaterialCode = arr[0].Code
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    //数量,金额保留两位小数
    fun(val) {
      return '折旧总金额：' + (Number(val) === 0 ? 0 : Number(val).toFixed(2))
    },
    addList() {
      this.$refs.Fittings.openDialog()
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Material/GetInventoryFlowsDataList', this.searchData)
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
        })
    },
    handleSearch() {
      console.log(this.rDate)

      this.searchData.sStorTime = this.rDate ? this.rDate[0] : ''
      this.searchData.eStorTime = this.rDate ? this.rDate[1] : ''
      if (
        this.searchData.sStorTime &&
        this.searchData.sStorTime &&
        this.searchData.MaterialId
      ) {
        this.getDataList()
      } else {
        this.$notify.warning('请选择日期与备件后查询')
      }
      console.log(this.searchData.MaterialId)
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    // this.getDataList();
  },
  computed: {
    ...mapState(['FittingsTreeSearch']),
  },
  watch: {
    FittingsTreeSearch() {
      this.searchData.MaterialId = ''
      this.MaterialName = ''
      this.MaterialCode = ''
      this.tableData = []
      // this.handleSearch();
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
